// Google Analytics 4 (gtag.js): pageviews y eventos de toda la app.
//
// - Sólo se usa el measurement ID (G-...); el stream ID es un identificador
//   interno de la propiedad GA4 y NO va en el código.
// - Carga como script externo (no inline) porque la CSP de vercel.json no
//   permite 'unsafe-inline' en script-src; los dominios habilitados viven ahí
//   (www.googletagmanager.com en script-src, collect regionales en connect-src).
// - Rutas SPA: SIN page_view manual. Enhanced Measurement ("Cambios de página
//   según el historial", activado por defecto en streams web) trackea los
//   pushState de React Router. Sumar tracking manual duplicaría pageviews
//   con eso activado. Si faltaran pageviews por ruta, es un toggle del
//   dashboard de GA4, no código.
// - Guards compartidos en analyticsGuards.ts (ver shouldLoadTracker).

import { shouldLoadTracker } from './analyticsGuards';

const GA_MEASUREMENT_ID = 'G-9R1JGL1CJ2';

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

export function initGtag(): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (!shouldLoadTracker(window.location.hostname, process.env.NODE_ENV === 'production', navigator.webdriver)) {
    return;
  }

  // Shim estándar de gtag.js: el snippet oficial hace esto mismo inline antes
  // de cargar el script (dataLayer + cola gtag), acá va en TS por la CSP.
  // OJO: gtag.js SÓLO procesa entradas tipo `arguments` en el dataLayer —
  // pushear arrays (['js', date] con rest params) se ignora silenciosamente
  // y el container queda en pre-init (verificado con probe: 0 hits).
  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function gtag() {
      // eslint-disable-next-line prefer-rest-params -- gtag.js requiere el objeto arguments real, no un array
      window.dataLayer!.push(arguments);
    };
  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID);

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);
}
